// extracted by mini-css-extract-plugin
export default {"user_main":"styles_user_main__2NGbe","section_title":"styles_section_title__Dr8RD","user_area":"styles_user_area__5Oj0C"};